const constants = {
	APP: 'app_error',
	GENERAL: 'general_error'
};

export default constants;
